export default "__VITE_ASSET__CejqQFC7__"